<template>
  <div class="content">
    <crm-client-form :datas="dataall"></crm-client-form>
    <b-modal id="modal-close" centered>
      <h4>
        {{$t('Sizda saqlanmagan malumotlar mavjud. Saqlansinmi?')}}
      </h4>

      <template #modal-footer="{ ok, cancel, hide }">
        <button type="button" class="btn btn-success" style="margin-bottom: 16px;"
          @click="$root.$refs.crmclient.Savedokument()">{{$t('Да')}}</button>
        <button type="button" class="btn btn-danger" @click='Home()'>{{$t('Нет')}}</button>
        <button type="button" class="btn btn-primary" @click="cancel()">{{$t('Отмена')}}</button>
      </template>
    </b-modal>
  </div>
</template>
<script>
import { CrmClientForm } from "@/pages";
export default {
  components: { CrmClientForm },
  data() {
    return {
      dataall: {
        first_name: "",
        last_name: "",
        middle_name: "",
        phone_number: "+998",
        work_id: null,
        work_address_id: null,
        found_address_id: null,
        found_datetime: 1,
        last_datetime: 1,
        contact_datetime: 1,
        probability: 0,
        status_id: null,
        comment: ""
      }
    };
  },
  watch: {
    dataall: {
      deep: true,
      handler(val, oldVal) {
        this.$store.state.saved += 1;
      }
    }
  },
  methods:{
    Home() {
        this.$store.state.saved = null;
        this.$bvModal.hide('modal-close');
        this.$router.push({ name: "Crm" });
      },
  },
  beforeRouteLeave(to, from, next) {
    if (this.$store.state.saved < 2) {
      this.$store.state.saved = null;
      next();
    } else {
      this.$bvModal.show("modal-close");
    }
  }
};
</script>
